import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../components/CustomTableWithPagination/GlobalTable';
import { TableHead_Refund_fn } from '../../components/datagrid/refund/RefundRequestTableHead';
import dayjs from 'dayjs';
import { getRerequestRaisedCount } from '../../redux/features/refundSlice';
import { useLocation } from 'react-router-dom';

export default function RerequestData() {
  const dispatch = useDispatch();
  const location = useLocation();

  const filters = location.state?.filters || {};

  const { data: tableRow, meta } = useSelector((state) => state.refund.rerequestRaisedCount);

  const loading = useSelector((state) => state.refund.loading);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    checkedRowIds: [],
    frozenColumns: [],
    hiddenColumns: [],
  });

  const [fromDate] = useState(filters?.fromDate || dayjs().startOf('month').format('YYYY-MM-DD'));

  const [toDate] = useState(filters?.toDate || dayjs().endOf('month').format('YYYY-MM-DD'));

  const dispatchParams = useMemo(() => {
    return {
      pageNum: tableState.page,
      gridSize: tableState.pageSize,
      search: filters?.search || '',
      fromDate,
      toDate,
      status: null,
      statusBy: filters?.statusBy === -1 ? null : filters?.statusBy,
      statusType: filters?.statusType === -1 ? null : filters?.statusType,
    };
  }, [tableState.page, tableState.pageSize, filters, fromDate, toDate]);
  useEffect(() => {
    dispatch(getRerequestRaisedCount(dispatchParams));
  }, [dispatch, dispatchParams]);

  // Find duplicates using enrollment id
  const duplicateRows = useMemo(() => {
    const grouped = {};

    tableRow?.forEach((item) => {
      const key = item.expense_course_enrollment_id;

      if (!grouped[key]) {
        grouped[key] = [];
      }

      grouped[key].push(item);
    });

    return Object.values(grouped)
      .filter((group) => group.length > 1)
      .flat();
  }, [tableRow]);

  const columns = useMemo(
    () =>
      TableHead_Refund_fn({
        selectedType: 0,
        approvalOrVerify: true,
        isFinance: true,
      }).filter(
        (col) => col.field !== 'sessions', // remove session column
      ),
    [],
  );
  return (
    <GlobalWrapper title="Re-request Raised Count">
      <Box sx={{ width: '100%' }}>
        <GlobalTable
          tableState={tableState}
          setTableState={setTableState}
          headers={columns}
          rows={tableRow}
          meta={{
            ...meta,
            totalRecords: meta?.totalRecords ?? tableRow?.length ?? 0,
          }}
          loading={loading}
          rowUniqueId="expense_id"
          exportUrl="refund-management/get-raise-request-rejected-datas"
          exportParams={{
            page: 1,
            limit: 'no',
            search: tableState.search,
            fromDate,
            toDate,
            status: null,
          }}
        />
      </Box>
    </GlobalWrapper>
  );
}
